// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.CreateManualPaymentWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { CreateManualPaymentWebApiHandler_createManualPayment } from '@zg-rentals/ts-rent-payment-client';

import type { CreateManualPaymentWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

export interface CreateManualPaymentWebApiHandler_createManualPayment_Args {
  postData: CreateManualPaymentWebApiRequestDto;
}

export type CreateManualPaymentWebApiHandler_createManualPayment_Options = UseMutationOptions<
  void,
  unknown,
  CreateManualPaymentWebApiHandler_createManualPayment_Args
>;

/**
 * Create a manual payment
 */
export const useCreateManualPaymentWebApiHandler_createManualPayment = ({
  httpClient,
  ...options
}: Omit<CreateManualPaymentWebApiHandler_createManualPayment_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CreateManualPaymentWebApiHandler_createManualPayment_Args) =>
      CreateManualPaymentWebApiHandler_createManualPayment(args.postData, httpClient),
  });
};
